var map = {
	"./icon-md-mood-01.svg": "ac60",
	"./icon-md-mood-02.svg": "5553",
	"./icon-md-mood-03.svg": "5001",
	"./icon-md-mood-04.svg": "b627",
	"./icon-md-mood-05.svg": "81cf",
	"./icon-md-mood-06.svg": "17d0",
	"./icon-md-mood-07.svg": "2666"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "14f2";